/**
 * Constantes e mensagens reutilizáveis para reduzir duplicação
 */

export const COMMON_MESSAGES = {
  WARNING_DISCLAIMER:
    'Os dados calculados ou inseridos manualmente no app, incluindo aqueles provenientes do seu relógio, não devem ser usados de forma isolada para diagnósticos ou recomendações médicas. Sempre consulte seu médico ou profissional de saúde para uma avaliação completa e orientações adequadas.',
  METRICS_DISCLAIMER:
    'Métricas isoladas são úteis, mas precisam ser analisadas em conjunto por profissionais da saúde para avaliações e tratamentos precisos.',
  RISK_LOW:
    '<b>0 – 9% Risco baixo:</b> Educação sobre hábitos saudáveis e monitoramento periódico.',
  RISK_MODERATE:
    '<b>10% - 20% Risco moderado:</b> Consultar um médico para avaliação detalhada e possíveis exames adicionais.',
  RISK_HIGH:
    '<b>20% Risco Alto:</b> Avaliação médica especializada, possível encaminhamento a um cardiologista e consideração de intervenções preventivas específicas.'
}

export const COMMON_REFERENCE_AREAS = {
  RISK_ZONES: [
    { y1: 0, y2: 10, fill: 'green' },
    { y1: 10, y2: 20, fill: 'yellow' },
    { y1: 20, y2: 100, fill: 'red' }
  ],
  HEALTH_SCORE: [
    { y1: 0, y2: 70, fill: 'red' },
    { y1: 70, y2: 80, fill: 'orange' },
    { y1: 80, y2: 95, fill: 'grey' },
    { y1: 95, y2: 100, fill: 'green' }
  ],
  BMI: [
    { y1: 0, y2: 18.5, fill: 'blue' },
    { y1: 18.5, y2: 24.9, fill: 'green' },
    { y1: 24.9, y2: 29.9, fill: 'yellow' },
    { y1: 29.9, y2: 100, fill: 'orange' }
  ],
  SLEEP_SCORE: [
    { y1: 0, y2: 50, fill: 'red' },
    { y1: 50, y2: 70, fill: 'yellow' },
    { y1: 70, y2: 100, fill: 'green' }
  ],
  STRESS_LEVEL: [
    { y1: 0, y2: 50, fill: 'green' },
    { y1: 50, y2: 100, fill: 'red' }
  ]
}

export const createRiskProtocol = (): string => {
  return `${COMMON_MESSAGES.RISK_LOW}<br /><br />${COMMON_MESSAGES.RISK_MODERATE}<br /><br />${COMMON_MESSAGES.RISK_HIGH}`
}

export const createInfoSection = (
  title: string,
  description: string,
  disclaimer: string = COMMON_MESSAGES.WARNING_DISCLAIMER
) => [
  { title, description },
  { title: 'Aviso Importante', description: disclaimer }
]
